<section *ngIf="cleanProfil" class="content__jobs" id="jobs-desc">
  <h2 class="content__title" i18n>Profil recherché</h2>
  <p itemprop="experienceRequirements" class="content__jobs__end-text">{{ cleanProfil }}</p>
</section>
